import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Business, License } from 'src/model/business';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { BusinessService } from 'src/services/business.service';
import { CompanyService } from 'src/services/company.service';
import { FinanceAccountService } from 'src/services/finance-account.service';
import { FormJService } from 'src/services/form-j.service';
import { LoanGroupService } from 'src/services/loan-group.service';
import { LoanRequestService } from 'src/services/loan-request.service';

@Component({
	selector: 'app-select-approved-ticket',
	standalone: false,
	templateUrl: './select-approved-ticket.component.html',
	styleUrl: './select-approved-ticket.component.scss'
})
export class SelectApprovedTicketComponent implements OnInit {
	@Output() passEntry = new EventEmitter<{
		entry: LoanRequest[];
		formJCompany: string;
		defaultFinanceAccount: FinanceAccount;
	}>();
	@Input() withLoan: boolean = false;
	@Input() customerId: number;
	@Input() addedLgIds: number[] = new Array();
	@Input() inUseFormJCompany = '';

	protected activeModal = inject(NgbActiveModal);
	protected sharedService = inject(SharedService);
	protected enums = inject(Enums);
	protected loanApprovalService = inject(LoanRequestService);
	protected formJService = inject(FormJService);
	protected businessService = inject(BusinessService);
	protected loanGroupService = inject(LoanGroupService);
	protected companyService = inject(CompanyService);
	protected financeAccountService = inject(FinanceAccountService);

	protected approvedTicketList: LoanRequest[] = new Array();
	protected sharedLoanRequestList: LoanRequest[] = new Array();
	protected defaultFinanceAccount: FinanceAccount;

	async ngOnInit(): Promise<void> {
		var startDate = await this.processStartDate();

		this.approvedTicketList = await this.loanApprovalService.getAllLoanApprovalRequest({
			approved: true,
			endDate: new Date().toISOString(),
			withLoan: this.withLoan,
			authorized: true,
			startDate: startDate?.toISOString(),
			customerId: this.customerId,
			showUninvolved: true
		});
		this.approvedTicketList = this.approvedTicketList.filter(t => this.addedLgIds.includes(t.LoanGroupId) == false);
	}

	async processStartDate() {
		var startDate;
		if (this.withLoan == true) {
			const today = new Date();
			// Normalize today (remove time)
			today.setHours(0, 0, 0, 0);

			startDate = new Date(today);

			//MAXIMUM: 3 DAYS BEFORE TODAY
			startDate.setDate(today.getDate() - 3);
		}

		return startDate;
	}
	async loadLoanGroupRequestAndSendParent(t: LoanRequest) {
		var error = await this.checkFormJ(t);

		if (error.length > 0) this.sharedService.openAlert(error, ALERT_TYPE.DANGER);
		else {
			if (this.warningApprovedLoan(t)) {
				this.confirmBeforeSelecting(t);
			} else this.sendInfoToParent(t);
		}
	}

	async checkFormJ(t: LoanRequest) {
    let license: License;
		let business: Business;
		let error: string = '';

		if (t.LoanInfo.Scheme == 'EPF') {
			let loanGroupDetails = await this.loanGroupService.getSingleLoanGroup(Number(t.LoanGroupId), true);
			let selectedFormJ = await this.formJService.getFormJDetails(loanGroupDetails.FormJId);
			license = await this.businessService.getLicense(selectedFormJ.LicenseId);
			business = await this.businessService.getBusiness(license.BusinessId);
			// if KERJA I use default Form J company
		} else {
			business = (await this.businessService.getAllBusinesses({ companyId: t.CompanyId }))[0];
		}

		//get business info
		if (business != undefined) {
      const financeAccts = await this.financeAccountService.getAllFinanceAccounts({businessId: business.Id});
			//so far there's no selection for finance account, so always take the first one!
			this.defaultFinanceAccount = financeAccts[0];

			if (this.inUseFormJCompany != '' && business.Name != this.inUseFormJCompany)
				error = `You cannot out this loan together because this is different Form J!\nIn use:  ${this.inUseFormJCompany} \nCurrent: ${business.Name}`;
			else this.inUseFormJCompany = business.Name;
		}

		return error;
	}

	async sendInfoToParent(t: LoanRequest) {
		this.sharedLoanRequestList = await this.loanApprovalService.getLoanGroupApprovalRequests(t.LoanGroupId);
		this.passEntry.emit({
			entry: this.sharedLoanRequestList,
			formJCompany: this.inUseFormJCompany,
			defaultFinanceAccount: this.defaultFinanceAccount
		});
		this.reset();
	}

	confirmBeforeSelecting(t: LoanRequest) {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent, 'largeModal');
		modalRef.componentInstance.message = 'This ticket approved more than 2 days! Please check if you already transferred to customer! Are you sure you want to proceed?';
		modalRef.componentInstance.confirmationType = this.enums.DANGER_CONFIRMATION;

		modalRef.result.then(confirm => {
			if (confirm) this.sendInfoToParent(t);
		});
	}

	warningApprovedLoan(r: LoanRequest) {
		const today = new Date();
		// Normalize today (remove time)
		today.setHours(0, 0, 0, 0);

		// Get cutoff date (2 days window → today - 1)
		const cutoffDate = new Date(today);
		cutoffDate.setDate(today.getDate() - 1);

		const processed = new Date(r.ProcessedOn);
		processed.setHours(0, 0, 0, 0);

		return processed < cutoffDate;
	}

	reset() {
		this.activeModal.close();
	}
}
